export const skills = [
  { id: 1, name: "Next.js / React.js", progress: 80 },
  { id: 2, name: "React Native", progress: 70 },
  { id: 3, name: "Node.js / Express.js", progress: 60 },
  { id: 4, name: "MongoDB", progress: 50 },
  { id: 5, name: "Firebase", progress: 70 },
  { id: 6, name: "Redux / Redux Toolkit", progress: 50 },
  { id: 7, name: "HTML, CSS, JavaScript", progress: 80 },
  { id: 8, name: "Tailwind CSS", progress: 40 },
  { id: 8, name: "Material UI", progress: 40 },
  { id: 8, name: "Git / Github", progress: 40 },
];

export const tools = [
  "Figma",
  "MongoDB Compass",
  "Version Control System",
  "Browser DevTools",
  "Postman",
  "Vs Code IDE",
  "Docker",
];

export const practices = [
  "Responsive first design",
  "Readability",
  "Code Quality",
  "Performance",
  "Security",
  "Accessibility",
  "Collaboration",
];
